// extracted by mini-css-extract-plugin
module.exports = {"input":"DatePickerFigo_input__392u0","icon":"DatePickerFigo_icon__ZKF3I"};